import Parse from "parse";

Parse.initialize("wehn");
Parse.serverURL = "https://parse-wehn.apps.openinc.dev/parse";
